// extracted by mini-css-extract-plugin
export default {"root":"VBReactProvider_root__CvE74","md":"VBReactProvider_md__lSfyd","sm":"VBReactProvider_sm__fJlc5"};